import { connect } from 'react-redux'
import Header from './Header'

import onChangeSearch from './Handlers/onChangeSearch'
import onSearch from './Handlers/onSearch'

const mapStateToProps = (state) => ({
  search: state.screens.SubProject.SubProjects.search,
})

const actionCreators = {
  onChangeSearch,
  onSearch,
}

export default connect(mapStateToProps, actionCreators)(Header)
